<template>
  <div id="home">
    <div class="personal-dashboard personal-dashboard-v1 container" v-loading="loading">
      <!--Header-->
      <div class="dashboard-header" style="margin-top: 30px">
        <div class="h-avatar is-large">
          <img class="avatar" :src="
              'https://yazilim.360hizliokuma.com/' + $store.state.user.image
            " data-demo-src="assets/img/avatars/photos/8.jpg" alt="" />
        </div>
        <div class="start">
          <h3>{{ $t("home.welcome") }} {{ $store.state.user.firstname }}</h3>
          <vue-typer style="font-size: 17px" class="dark-inverted" :text="sozler"></vue-typer>
        </div>
      </div>

      <div class="row mb-5">
        <router-link :to="{ name: 'Courses' }" :class="
            $i18n.locale != 'az' && $store.state.user.level != 'İlkokul'
              ? 'col-md-4'
              : 'col-md-6'
          ">
          <div class="card shadow-lg border-0">
            <div class="
                card-body
                d-flex
                flex-column
                align-items-center
                justify-content-center
              ">
              <img src="/static/images/menu-icons/courses_solid.svg" style="width: 80px; height: 80px" />
              <h1 style="font-size: 36px">{{ $t("menu.courses") }}</h1>
            </div>
          </div>
        </router-link>

        <router-link :to="{
            name:
              $store.state.user.level == 'İlkokul'
                ? 'ExercisesChild'
                : 'Exercises',
          }" :class="
            $i18n.locale != 'az' && $store.state.user.level != 'İlkokul'
              ? 'col-md-4'
              : 'col-md-6'
          ">
          <div class="card shadow-lg border-0">
            <div class="
                card-body
                d-flex
                flex-column
                align-items-center
                justify-content-center
              ">
              <img src="/static/images/menu-icons/exercises_solid.svg" style="
                  width: 65px;
                  margin-top: 7.5px;
                  margin-bottom: 7.5px;
                  height: 65px;
                  margin-top: 7.5px;
                  margin-bottom: 7.5px;
                " />
              <h1 style="font-size: 36px">{{ $t("menu.exercises") }}</h1>
            </div>
          </div>
        </router-link>

        <router-link :to="{ name: 'Tests' }" class="col-md-4"
          v-if="$i18n.locale != 'az' && $store.state.user.level != 'İlkokul'">
          <div class="card shadow-lg border-0">
            <div class="
                card-body
                d-flex
                flex-column
                align-items-center
                justify-content-center
              ">
              <img src="/static/images/menu-icons/tests_solid.svg" style="width: 80px; height: 80px" />
              <h1 style="font-size: 36px">{{ $t("menu.tests") }}</h1>
            </div>
          </div>
        </router-link>
      </div>

      <div class="row" v-if="
          $store.state.user.level != 'LGS' && $store.state.user.level != 'YKS'
        ">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-6">
              <div class="card border-0 shadow-lg p-3">
                <div class="media-flex-center w-100">
                  <div class="flex-meta d-flex flex-fill flex-column ml-1">
                    <span style="font-size: 26px">{{
                      speed_tests.length > 1
                      ? speed_tests[0].word_per_minute + $t("home.kdk")
                      : "-"
                      }}</span>
                    <span>{{ $t("home.last_speed") }}</span>
                  </div>
                  <div class="h-icon is-purple is-rounded">
                    <i class="lnil lnil-analytics-alt-1"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card border-0 shadow-lg p-3">
                <div class="media-flex-center w-100">
                  <div class="flex-meta d-flex flex-fill flex-column ml-1">
                    <span style="font-size: 26px">{{
                      speed_tests.length > 1
                      ? "%" + speed_tests[0].understanding_rate
                      : "-"
                      }}</span>
                    <span>{{ $t("home.last_under") }}</span>
                  </div>
                  <div class="h-icon is-purple is-rounded">
                    <i class="lnil lnil-analytics-alt-1"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mt-5">
              <div class="card border-0 shadow-lg p-3">
                <div class="media-flex-center w-100">
                  <div class="flex-meta d-flex flex-fill flex-column ml-1">
                    <span style="font-size: 26px">{{
                      speed_tests.length > 0
                      ? speed_tests[speed_tests.length - 1].word_per_minute +
                      $t("home.kdk")
                      : "-"
                      }}</span>
                    <span>{{ $t("home.first_speed") }}</span>
                  </div>
                  <div class="h-icon is-purple is-rounded">
                    <i class="lnil lnil-analytics-alt-1"></i>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 mt-5">
              <div class="card border-0 shadow-lg p-3">
                <div class="media-flex-center w-100">
                  <div class="flex-meta d-flex flex-fill flex-column ml-1">
                    <span style="font-size: 26px">{{
                      speed_tests.length > 0
                      ? "%" +
                      speed_tests[speed_tests.length - 1].understanding_rate
                      : "-"
                      }}</span>
                    <span>{{ $t("home.first_under") }}</span>
                  </div>
                  <div class="h-icon is-purple is-rounded">
                    <i class="lnil lnil-analytics-alt-1"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card border-0 shadow-lg p-5">
            <h1 style="font-size: 20px; font-weight: bold">
              {{ $t("home.gain") }}
            </h1>
            <p style="font-weight: bold; font-size: 40px" v-if="
                speed_tests.length &&
                speed_tests[speed_tests.length - 1].word_per_minute >
                  speed_tests[0].word_per_minute
              ">
              <small style="font-size: 53%">%</small>{{
              Math.round(
              (speed_tests[speed_tests.length - 1].word_per_minute /
              speed_tests[0].word_per_minute) *
              100
              )
              }}
            </p>
            <p style="font-weight: bold; font-size: 40px" v-if="speed_tests.length == 0">
              -
            </p>
            <p style="font-weight: bold; font-size: 40px; color: #4a9d77" v-if="
                speed_tests.length &&
                speed_tests[speed_tests.length - 1].word_per_minute <
                  speed_tests[0].word_per_minute
              ">
              <small style="font-size: 53%">%</small>{{
              Math.round(
              (speed_tests[0].word_per_minute /
              speed_tests[speed_tests.length - 1].word_per_minute) *
              100
              )
              }}
            </p>

            <span style="color: #4a9d77">{{ $t("home.start_date") }}</span>
            <span>{{
              speed_tests.length > 1
              ? moment(speed_tests[0].createdAt).format("LL")
              : "-"
              }}</span>

            <div style="position: absolute; right: 20px; top: 40px" v-if="speed_tests.length > 1">
              <div class="cta-content" style="font-size: 30px" v-if="speed_tests.length > 1">
                <i class="fas fa-chevron-down" style="color: #f24d5d" v-if="
                    speed_tests[speed_tests.length - 1].word_per_minute >
                    speed_tests[0].word_per_minute
                  "></i>
                <i class="fas fa-chevron-up" style="color: #4a9d77" v-else></i>
              </div>
              <div v-else class="cta-content" style="font-size: 30px">
                <h1 style="font-size: 24px; font-weight: bold; color: white">
                  {{ $t("home.gain") }}
                </h1>
                <i class="fas fa-hourglass-half" style="color: white"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="search-results-body mt-5" v-if="
          $store.state.user.test_required == 1 ||
          $store.state.user.test_required_exam == 1
        ">
        <!--Search Placeholder -->
        <div class="page-placeholder">
          <div class="placeholder-content" style="width: 100%">
            <img class="light-image" v-if="
                $store.state.user.test_required == 1 ||
                $store.state.user.test_required_exam == 1
              " src="assets/img/illustrations/placeholders/search-7.svg" alt="" />
            <img v-if="
                $store.state.user.test_required == 1 ||
                $store.state.user.test_required_exam == 1
              " class="dark-image" src="assets/img/illustrations/placeholders/search-7-dark.svg" alt="" />
            <img v-if="
                $store.state.user.test_required == 1 ||
                $store.state.user.test_required_exam == 1
              " src="/static/img/home.svg" style="width: 800px" />

            <h3 class="mb-3" v-if="
                $store.state.user.test_required == 1 ||
                $store.state.user.test_required_exam == 1
              ">
              {{ $t("home.read.title") }}
            </h3>
            <p class="is-larger mb-3" v-if="
                $store.state.user.test_required == 1 ||
                $store.state.user.test_required_exam == 1
              ">
              {{ $t("home.read.desc") }}
            </p>
            <button v-if="
                $store.state.user.test_required == 1 ||
                $store.state.user.test_required_exam == 1
              " @click="
                $router.push({
                  name:
                    $store.state.user.test_required_exam == 1
                      ? 'SinavSpeedTest'
                      : 'SpeedTest',
                })
              " class="button h-button is-danger is-rounded is-elevated">
              <span>{{ $t("home.read.start") }}</span>
            </button>
          </div>
        </div>
      </div>

      <el-collapse v-model="activeTab">
        <el-collapse-item :title="$t('gelisim')" name="1">
          <div class="
              col-md-12
              d-flex
              align-items-center
              justify-content-center
              mt-5
              flex-column
            ">
            <div style="width: 100%" class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <div class="card border-0 shadow-lg p-3">
                      <div class="media-flex-center w-100">
                        <div class="flex-meta d-flex flex-fill flex-column ml-1">
                          <span style="font-size: 26px">{{
                            speed_tests.length > 1
                            ? speed_tests[0].word_per_minute + $t("home.kdk")
                            : "-"
                            }}</span>
                          <span>{{ $t("home.last_speed") }}</span>
                        </div>
                        <div class="h-icon is-purple is-rounded">
                          <i class="lnil lnil-analytics-alt-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="card border-0 shadow-lg p-3">
                      <div class="media-flex-center w-100">
                        <div class="flex-meta d-flex flex-fill flex-column ml-1">
                          <span style="font-size: 26px">{{
                            speed_tests.length > 1
                            ? "%" + speed_tests[0].understanding_rate
                            : "-"
                            }}</span>
                          <span>{{ $t("home.last_under") }}</span>
                        </div>
                        <div class="h-icon is-purple is-rounded">
                          <i class="lnil lnil-analytics-alt-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 mt-5">
                    <div class="card border-0 shadow-lg p-3">
                      <div class="media-flex-center w-100">
                        <div class="flex-meta d-flex flex-fill flex-column ml-1">
                          <span style="font-size: 26px">{{
                            speed_tests.length > 0
                            ? speed_tests[speed_tests.length - 1]
                            .word_per_minute + $t("home.kdk")
                            : "-"
                            }}</span>
                          <span>{{ $t("home.first_speed") }}</span>
                        </div>
                        <div class="h-icon is-purple is-rounded">
                          <i class="lnil lnil-analytics-alt-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 mt-5">
                    <div class="card border-0 shadow-lg p-3">
                      <div class="media-flex-center w-100">
                        <div class="flex-meta d-flex flex-fill flex-column ml-1">
                          <span style="font-size: 26px">{{
                            speed_tests.length > 0
                            ? "%" +
                            speed_tests[speed_tests.length - 1]
                            .understanding_rate
                            : "-"
                            }}</span>
                          <span>{{ $t("home.first_under") }}</span>
                        </div>
                        <div class="h-icon is-purple is-rounded">
                          <i class="lnil lnil-analytics-alt-1"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="card border-0 shadow-lg p-5">
                  <h1 style="font-size: 20px; font-weight: bold">
                    {{ $t("home.gain") }}
                  </h1>
                  <p style="font-weight: bold; font-size: 40px" v-if="
                      speed_tests.length &&
                      speed_tests[speed_tests.length - 1].word_per_minute >
                        speed_tests[0].word_per_minute
                    ">
                    <small style="font-size: 53%">%</small>{{
                    Math.round(
                    (speed_tests[speed_tests.length - 1].word_per_minute /
                    speed_tests[0].word_per_minute) *
                    100
                    )
                    }}
                  </p>
                  <p style="font-weight: bold; font-size: 40px" v-if="speed_tests.length == 0">
                    -
                  </p>
                  <p style="font-weight: bold; font-size: 40px; color: #4a9d77" v-if="
                      speed_tests.length &&
                      speed_tests[speed_tests.length - 1].word_per_minute <
                        speed_tests[0].word_per_minute
                    ">
                    <small style="font-size: 53%">%</small>{{
                    Math.round(
                    (speed_tests[0].word_per_minute /
                    speed_tests[speed_tests.length - 1].word_per_minute) *
                    100
                    )
                    }}
                  </p>

                  <span style="color: #4a9d77">{{
                    $t("home.start_date")
                    }}</span>
                  <span>{{
                    speed_tests.length > 1
                    ? moment(speed_tests[0].createdAt).format("LL")
                    : "-"
                    }}</span>

                  <div style="position: absolute; right: 20px; top: 40px" v-if="speed_tests.length > 1">
                    <div class="cta-content" style="font-size: 30px" v-if="speed_tests.length > 1">
                      <i class="fas fa-chevron-down" style="color: #f24d5d" v-if="
                          speed_tests[speed_tests.length - 1].word_per_minute >
                          speed_tests[0].word_per_minute
                        "></i>
                      <i class="fas fa-chevron-up" style="color: #4a9d77" v-else></i>
                    </div>
                    <div v-else class="cta-content" style="font-size: 30px">
                      <h1 style="font-size: 24px; font-weight: bold; color: white">
                        {{ $t("home.gain") }}
                      </h1>
                      <i class="fas fa-hourglass-half" style="color: white"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item :title="$t('sorugelisim')" name="2" v-if="$store.state.user.speed_test_exam.length > 0">
          <div class="row">
            <div class="
                col-md-12
                d-flex
                align-items-center
                justify-content-center
                mt-5
                flex-column
              ">
              <div class="row" style="width: 100%">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="card border-0 shadow-lg p-3">
                        <div class="media-flex-center w-100">
                          <div class="flex-meta d-flex flex-fill flex-column ml-1">
                            <span style="font-size: 26px">{{
                              $store.state.user.speed_test_exam.length > 1
                              ? $store.state.user.speed_test_exam[0]
                              .word_per_minute + $t("home.kdk")
                              : "-"
                              }}</span>
                            <span>{{ $t("home.last_speed") }}</span>
                          </div>
                          <div class="h-icon is-purple is-rounded">
                            <i class="lnil lnil-analytics-alt-1"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="card border-0 shadow-lg p-3">
                        <div class="media-flex-center w-100">
                          <div class="flex-meta d-flex flex-fill flex-column ml-1">
                            <span style="font-size: 26px">{{
                              $store.state.user.speed_test_exam.length > 1
                              ? "%" +
                              $store.state.user.speed_test_exam[0]
                              .understanding_rate
                              : "-"
                              }}</span>
                            <span>{{ $t("home.last_under") }}</span>
                          </div>
                          <div class="h-icon is-purple is-rounded">
                            <i class="lnil lnil-analytics-alt-1"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mt-5">
                      <div class="card border-0 shadow-lg p-3">
                        <div class="media-flex-center w-100">
                          <div class="flex-meta d-flex flex-fill flex-column ml-1">
                            <span style="font-size: 26px">{{
                              $store.state.user.speed_test_exam.length > 0
                              ? $store.state.user.speed_test_exam[
                              $store.state.user.speed_test_exam.length - 1
                              ].word_per_minute + $t("home.kdk")
                              : "-"
                              }}</span>
                            <span>{{ $t("home.first_speed") }}</span>
                          </div>
                          <div class="h-icon is-purple is-rounded">
                            <i class="lnil lnil-analytics-alt-1"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 mt-5">
                      <div class="card border-0 shadow-lg p-3">
                        <div class="media-flex-center w-100">
                          <div class="flex-meta d-flex flex-fill flex-column ml-1">
                            <span style="font-size: 26px">{{
                              $store.state.user.speed_test_exam.length > 0
                              ? "%" +
                              $store.state.user.speed_test_exam[
                              $store.state.user.speed_test_exam.length - 1
                              ].understanding_rate
                              : "-"
                              }}</span>
                            <span>{{ $t("home.first_under") }}</span>
                          </div>
                          <div class="h-icon is-purple is-rounded">
                            <i class="lnil lnil-analytics-alt-1"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card border-0 shadow-lg p-5">
                    <h1 style="font-size: 20px; font-weight: bold">
                      {{ $t("home.gain") }}
                    </h1>
                    <p style="font-weight: bold; font-size: 40px" v-if="
                        $store.state.user.speed_test_exam.length &&
                        $store.state.user.speed_test_exam[
                          $store.state.user.speed_test_exam.length - 1
                        ].word_per_minute >
                          $store.state.user.speed_test_exam[0].word_per_minute
                      ">
                      <small style="font-size: 53%">%</small>{{
                      Math.round(
                      ($store.state.user.speed_test_exam[
                      $store.state.user.speed_test_exam.length - 1
                      ].word_per_minute /
                      $store.state.user.speed_test_exam[0]
                      .word_per_minute) *
                      100
                      )
                      }}
                    </p>
                    <p style="font-weight: bold; font-size: 40px" v-if="$store.state.user.speed_test_exam.length == 0">
                      -
                    </p>
                    <p style="font-weight: bold; font-size: 40px; color: #4a9d77" v-if="
                        $store.state.user.speed_test_exam.length &&
                        $store.state.user.speed_test_exam[
                          $store.state.user.speed_test_exam.length - 1
                        ].word_per_minute <
                          $store.state.user.speed_test_exam[0].word_per_minute
                      ">
                      <small style="font-size: 53%">%</small>{{
                      Math.round(
                      ($store.state.user.speed_test_exam[0]
                      .word_per_minute /
                      $store.state.user.speed_test_exam[
                      $store.state.user.speed_test_exam.length - 1
                      ].word_per_minute) *
                      100
                      )
                      }}
                    </p>

                    <span style="color: #4a9d77">{{
                      $t("home.start_date")
                      }}</span>
                    <span>{{
                      $store.state.user.speed_test_exam.length > 1
                      ? moment(
                      $store.state.user.speed_test_exam[0].createdAt
                      ).format("LL")
                      : "-"
                      }}</span>

                    <div style="position: absolute; right: 20px; top: 40px"
                      v-if="$store.state.user.speed_test_exam.length > 1">
                      <div class="cta-content" style="font-size: 30px"
                        v-if="$store.state.user.speed_test_exam.length > 1">
                        <i class="fas fa-chevron-down" style="color: #f24d5d" v-if="
                            $store.state.user.speed_test_exam[
                              $store.state.user.speed_test_exam.length - 1
                            ].word_per_minute >
                            $store.state.user.speed_test_exam[0].word_per_minute
                          "></i>
                        <i class="fas fa-chevron-up" style="color: #4a9d77" v-else></i>
                      </div>
                      <div v-else class="cta-content" style="font-size: 30px">
                        <h1 style="
                            font-size: 24px;
                            font-weight: bold;
                            color: white;
                          ">
                          {{ $t("home.gain") }}
                        </h1>
                        <i class="fas fa-hourglass-half" style="color: white"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>

      <!--Body-->
      <div class="dashboard-body mt-5">
        <div class="columns is-multiline">
          <!--Card-->
          <div class="column is-12" v-if="
              ($store.state.user.level != 'İlkokul' &&
                speed_tests.length > 1) ||
              ($store.state.user.level == 'İlkokul' &&
                $store.state.user.speed_test_io.length > 1)
            ">
            <div class="dashboard-card" style="position: relative">
              <h1 style="font-weight: 600; font-size: 20px" class="dark-inverted">
                {{ $t("home.stats") }}
              </h1>
              <div id="chartdiv" style="height: 400px"></div>
              <img src="/static/images/Logo-Verticaltr.svg" style="
                  position: absolute;
                  right: 10px;
                  bottom: 10px;
                  width: 40px;
                " alt="" />
            </div>
          </div>

          <!--Card-->
        </div>
      </div>

      <div class="dashboard-body mt-5">
        <div class="columns is-multiline">
          <!--Card-->
          <div class="column is-12" v-if="$store.state.user.speed_test_exam.length">
            <div class="dashboard-card" style="position: relative">
              <h1 style="font-weight: 600; font-size: 20px" class="dark-inverted">
                Soru Okuma İstatistikleri
              </h1>
              <div id="chartdivexam" style="height: 400px"></div>
              <img src="/static/images/Logo-Verticaltr.svg" style="
                  position: absolute;
                  right: 10px;
                  bottom: 10px;
                  width: 40px;
                " alt="" />
            </div>
          </div>

          <!--Card-->
        </div>
      </div>

      <div class="row mt-5" v-if="stats.filter((k) => k.types == 'tepki').length > 0">
        <div class="col-md-6">
          <div class="card border-0 shadow-lg p-3">
            <div class="media-flex-center w-100">
              <div class="flex-meta d-flex flex-fill flex-column ml-1" style="
                  background-image: url(/static/3064677.png);
                  background-repeat: no-repeat;
                  background-position: right;
                  background-size: contain;
                ">
                <h1 style="font-size: 20px; font-weight: bold">
                  {{ $t("home.tepki") }}
                </h1>
                <span style="font-size: 46px; color: #4a9d77; font-weight: bold" v-if="
                    stats.filter((k) => k.types == 'tepki').length > 0 &&
                    lodash.orderBy(
                      stats.filter((k) => k.types == 'tepki'),
                      ['gain'],
                      ['desc']
                    )[0].gain -
                      100 >
                      0
                  ">
                  <small>%</small>{{
                  (
                  lodash.orderBy(
                  stats.filter((k) => k.types == "tepki"),
                  ["gain"],
                  ["desc"]
                  )[0].gain - 100
                  ).toFixed(0)
                  }}
                </span>
                <span style="font-size: 46px; color: #f24d5d; font-weight: bold" v-if="
                    stats.filter((k) => k.types == 'tepki').length > 0 &&
                    lodash.orderBy(
                      stats.filter((k) => k.types == 'tepki'),
                      ['gain'],
                      ['desc']
                    )[0].gain -
                      100 <
                      0
                  ">
                  <small>%</small>{{
                  (
                  lodash.orderBy(
                  stats.filter((k) => k.types == "tepki"),
                  ["gain"],
                  ["desc"]
                  )[0].gain - 100
                  ).toFixed(0)
                  }}
                  <i class="fas fa-arrow-down fa-1x color-danger" style="position: absolute; right: 10px"></i>
                </span>

                <span v-if="stats.filter((k) => k.types == 'tepki').length > 0">{{ $t("home.eniyi") }}
                  {{
                  parseFloat(
                  lodash.orderBy(
                  stats.filter((k) => k.types == "tepki"),
                  ["score"],
                  ["asc"]
                  )[0].score
                  ).toFixed(0)
                  }}
                  {{ $t("home.milisaniye") }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6" v-if="stats.filter((k) => k.types == 'dikkat').length > 0">
          <div class="card border-0 shadow-lg p-3">
            <div class="media-flex-center w-100">
              <div class="flex-meta d-flex flex-fill flex-column ml-1" style="
                  background-image: url(/static/2285039.png);
                  background-repeat: no-repeat;
                  background-position: right;
                  background-size: contain;
                ">
                <h1 style="font-size: 20px; font-weight: bold">
                  {{ $t("home.dikkat") }}
                </h1>
                <span style="font-size: 46px; color: #4a9d77; font-weight: bold" v-if="
                    stats.filter((k) => k.types == 'dikkat').length > 0 &&
                    lodash.orderBy(
                      stats.filter((k) => k.types == 'dikkat'),
                      ['gain'],
                      ['desc']
                    )[0].gain -
                      100 >
                      0
                  ">
                  <small>%</small>{{
                  (
                  lodash.orderBy(
                  stats.filter((k) => k.types == "dikkat"),
                  ["gain"],
                  ["desc"]
                  )[0].gain - 100
                  ).toFixed(0)
                  }}
                </span>
                <span style="font-size: 46px; color: #f24d5d; font-weight: bold" v-if="
                    stats.filter((k) => k.types == 'dikkat').length > 0 &&
                    lodash.orderBy(
                      stats.filter((k) => k.types == 'dikkat'),
                      ['gain'],
                      ['desc']
                    )[0].gain -
                      100 <
                      0
                  ">
                  <small>%</small>{{
                  (
                  lodash.orderBy(
                  stats.filter((k) => k.types == "dikkat"),
                  ["gain"],
                  ["desc"]
                  )[0].gain - 100
                  ).toFixed(0)
                  }}
                  <i class="fas fa-arrow-down fa-1x color-danger" style="position: absolute; right: 10px"></i>
                </span>

                <span v-if="stats.filter((k) => k.types == 'dikkat').length > 0">{{ $t("home.enyuksek") }}
                  {{
                  parseFloat(
                  lodash.orderBy(
                  stats.filter((k) => k.types == "dikkat"),
                  ["score"],
                  ["desc"]
                  )[0].score
                  )
                  }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 mt-5" v-if="stats.filter((k) => k.types == 'hafiza').length > 0">
          <div class="card border-0 shadow-lg p-3">
            <div class="media-flex-center w-100">
              <div class="flex-meta d-flex flex-fill flex-column ml-1" style="
                  background-image: url(/static/3997692.png);
                  background-repeat: no-repeat;
                  background-position: right;
                  background-size: contain;
                ">
                <h1 style="font-size: 20px; font-weight: bold">
                  {{ $t("home.hafiza") }}
                </h1>
                <span style="font-size: 46px; color: #4a9d77; font-weight: bold" v-if="
                    stats.filter((k) => k.types == 'hafiza').length > 0 &&
                    lodash.orderBy(
                      stats.filter((k) => k.types == 'hafiza'),
                      ['gain'],
                      ['desc']
                    )[0].gain -
                      100 >
                      0
                  ">
                  <small>%</small>{{
                  (
                  lodash.orderBy(
                  stats.filter((k) => k.types == "hafiza"),
                  ["gain"],
                  ["desc"]
                  )[0].gain - 100
                  ).toFixed(0)
                  }}
                </span>
                <span style="font-size: 46px; color: #f24d5d; font-weight: bold" v-if="
                    stats.filter((k) => k.types == 'hafiza').length > 0 &&
                    lodash.orderBy(
                      stats.filter((k) => k.types == 'hafiza'),
                      ['gain'],
                      ['desc']
                    )[0].gain -
                      100 <
                      0
                  ">
                  <small>%</small>{{
                  (
                  lodash.orderBy(
                  stats.filter((k) => k.types == "hafiza"),
                  ["gain"],
                  ["desc"]
                  )[0].gain - 100
                  ).toFixed(0)
                  }}
                  <i class="fas fa-arrow-down fa-1x color-danger" style="position: absolute; right: 10px"></i>
                </span>

                <span v-if="stats.filter((k) => k.types == 'hafiza').length > 0">{{ $t("home.enyuksek") }}
                  {{
                  parseFloat(
                  lodash.orderBy(
                  stats.filter((k) => k.types == "hafiza"),
                  ["score"],
                  ["desc"]
                  )[0].score
                  )
                  }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 mt-5" v-if="stats.filter((k) => k.types == 'matematik').length > 0">
          <div class="card border-0 shadow-lg p-3">
            <div class="media-flex-center w-100">
              <div class="flex-meta d-flex flex-fill flex-column ml-1" style="
                  background-image: url(/static/2436635.png);
                  background-repeat: no-repeat;
                  background-position: right;
                  background-size: contain;
                ">
                <h1 style="font-size: 20px; font-weight: bold">
                  {{ $t("home.zihinsel") }}
                </h1>
                <span style="font-size: 46px; color: #4a9d77; font-weight: bold" v-if="
                    stats.filter((k) => k.types == 'matematik').length > 0 &&
                    lodash.orderBy(
                      stats.filter((k) => k.types == 'matematik'),
                      ['gain'],
                      ['desc']
                    )[0].gain -
                      100 >
                      0
                  ">
                  <small>%</small>{{
                  (
                  lodash.orderBy(
                  stats.filter((k) => k.types == "matematik"),
                  ["gain"],
                  ["desc"]
                  )[0].gain - 100
                  ).toFixed(0)
                  }}
                </span>
                <span style="font-size: 46px; color: #f24d5d; font-weight: bold" v-if="
                    stats.filter((k) => k.types == 'matematik').length > 0 &&
                    lodash.orderBy(
                      stats.filter((k) => k.types == 'matematik'),
                      ['gain'],
                      ['desc']
                    )[0].gain -
                      100 <
                      0
                  ">
                  <small>%</small>{{
                  (
                  lodash.orderBy(
                  stats.filter((k) => k.types == "matematik"),
                  ["gain"],
                  ["desc"]
                  )[0].gain - 100
                  ).toFixed(0)
                  }}
                  <i class="fas fa-arrow-down fa-1x color-danger" style="position: absolute; right: 10px"></i>
                </span>

                <span v-if="stats.filter((k) => k.types == 'matematik').length > 0">{{ $t("home.enyuksek") }}
                  {{
                  parseFloat(
                  lodash.orderBy(
                  stats.filter((k) => k.types == "matematik"),
                  ["score"],
                  ["desc"]
                  )[0].score
                  )
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";
import axios from "axios";
import { VueTyper } from "vue-typer";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import Calendar from "v-calendar/lib/components/calendar.umd";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import Course from "../components/Course.vue";
import _ from "lodash";
import moment from "moment";
moment.locale("tr");
export default {
  name: "Home",
  mixins: [],
  components: {
    Course,
    VueTyper,
    "vue-typer": VueTyper,
    "v-calendar": Calendar,
  },
  computed: {
    speed_tests() {
      if (this.$store.state.user.level == "İlkokul") {
        return _.sortBy(
          this.$store.state.user.speed_test_io,
          function (dateObj) {
            return new Date(dateObj.createdAt);
          }
        ).reverse();
      }

      return this.$store.state.user.speed_tests;
    },
  },
  data() {
    return {
      examStats: false,
      lodash: _,
      test_required: 0,
      activeTab: "1",
      sozler:
        this.$i18n.locale == "tr" || this.$i18n.locale == "az"
          ? `“Okumak gıdadır okuyan insanlık bilen insandır.” Victor Hugo||“Düşünmeden okumak hazmetmeden yemeğe benzer.” Edmund Burke||“Ömrünün dörtte üçünü okumakla geçiren muhakkak namuslu olur.” Denis Diderot||“Okuma ihtiyacı barut gibidir bir kere tutuşunca artık sönmez.” Victor Hugo||“Her okur bir lider değildir fakat her lider bir okur olmalıdır.” Harry Truman||“Okulda okudukları ile yetinenler yalnız bakıcılarıyla konuşabilen çocuklara benzerler.” Voltaire||“Kitapları yakmaktan daha büyük bir suç varsa o da onları okumamaktır.” Joseph Brodsky||“Kendimizden ne kadar habersiz olduğumuzu yazdıklarımızı yeniden okurken anlarız.” Paul Walery||“Okumayı sevmek hayattaki can sıkıcı saatleri güzel saatlerle değiştirmektir.” Charles de Montesquieu||“Eğer bir insan bir kitabı okuduktan sonra onu tekrar okumaktan zevk almıyorsa o kitabı okumuş olmasının hiçbir değeri yoktur.” – Oscar Wilde||“Ne kadar çok okursanız o kadar çok öğrenir ve güç kazanır yaşamınızın denetimini kendi ellerinize alırsınız.” Roz Townsend||“Ne kadar meşgul olduğunu düşünürsen düşün okumak için zaman ayırmazsan cahilliğe teslim olursun.” Konfüçyus||“İnsan her gün bir parça müzik dinlemeli, iyi bir şiir okumalı, güzel bir tablo görmeli ve mümkünse birkaç mantıklı cümle söylemelidir” – Goethe||“Okuyun, diyor okuyun. Çünkü mürekkebin akmadığı yerde kan akıyor.” – Ali Şeriati||“Bir ülkede okumaya karşı istek artmadıkça gaflet ve bu gafletten doğacak felaketler azalmaz.” Benjamin Franklin||“Kurnaz insan okumayı küçümser basit insan ona hayran olur akıllı insan ise ondan yararlanır.” Francis Bacon||“Korku ve ürkeklik içinde başlayan günlerimde okuyarak cesaretimi artırmasını öğrendim.” C. Henderson||“Kitap okumayan bir kimsenin okumasını bilmeyene karşı bir üstünlüğü yoktur.” Mark Twain||“Hiçbir zaman kötü kitaplar çok az ya da iyi kitaplar çok fazla okunmaz: kötü kitaplar zihin için zehir mesabesindedir, aklı harap ederler. İyi olanı okumak için kötü olanı hiçbir zaman okumamayı insan kendisine düstur edinmeli: çünkü hayat kısa ve hem zaman hem dinçlik insan için sınırlı.” – Arthur Schopenhauer||“Yediğimiz her şeyin hazım esnasında lezzetinden başka etkileri de olduğu gibi okuduklarımızın bize verdiği zevkten başka etkileri de vardır.” – T. S. Eliot||“Sen şimdi bunları birkaç saat içinde okuyacaksın fakat inan bana ben bu işi yapabilmek için saçlarım ağarıncaya kadar çalıştım.” Charles de Montesquieu||“Okumayı bilen bir kimse kendini yüceltme çok yönlü olabilme yaşamını ilginç üstün ve kusursuz yapabilme gücüne de sahip demektir.” Henry Huxley||“Okumanın sonu düşünceyi karşısına çıkan bütün şeyler üzerine sağlam ve doğru hükümler verecek şekilde idare etmek olmalıdır.” – Rene Descartes||“Okuma insanın zihinsel giysilerini dokuyan bir tezgahtır. Bayağı şeyler okumak hem beyine hem kalbe bayağı giysiler dokur.” A. P. Gouthey||“Olgun bir okuyucu çoğu kez başkasının yazdıklarında yazarın düşünmediği güzellikler bulur okuduklarına daha zengin anlamlar ve renkler kazandırır.” Montaigne||“Her gün tek bir cümle bile olsa birazcık okuyarak ilerleyin eğer her gün on beş dakikanızı verirseniz yılın sonunda bunun etkisini hissedersiniz.” Horace Mann||“Bizi güçlü yapan yediklerimiz değil hazmettiklerimizdir bizi zengin yapan kazandıklarımız değil muhafaza ettiklerimizdir bizi bilgili yapan okuduklarımız değil kafamıza yerleştirdiklerimizdir.” Francis Bacon||“İnsanın tekrar tekrar okuduğu, aklının demirbaşları arasında yerini alan ve hayata bakışını değiştiren kitaplar vardır; göz atıp asla baştan sona okumadığı, bir oturuşta okuyup bir hafta sonra unuttuğu kitaplar da.” – George Orwell||“Okuldaki eğitim, hayatınızı idame ettirmenizi sağlar. Kendinizi eğitmeniz ise, size bir servet kazandırır.” – Jim Rohn||“Okumak, alışkanlıkların en asilidir.” Antoine Albalat||“Her yara kitap ayıracı gibi durur hayatımızda. “Nerede kalmıştık” deriz, devam ederiz.”||“Kitaplar da dost gibidir, az fakat iyi seçilmiş olmalıdır.”||“Geçmişi bir kitap gibi kullanın, eviniz gibi değil.”||“En huzurlu yalnızlığı kitap ayraçları yaşıyor.”||“Kitap karıştırmayan ortalık karıştırır.”||“Bol bol okuyun. Okumak gerçekten çok yardımcı olur. Elinize geçen hemen hemen her şeyi okuyun.”||“Kitapsız büyüyen çocuk, susuz büyüyen ağaca benzer.”||“Yetişen zekaları kitaplarla beslemeyen uluslar, yıkılmaya mahkumdurlar.”||“Kitapları seviyor musunuz öyleyse hayatınız boyunca mutlu olacaksınız demektir.” – (Jules Chore)||“Kitaplar kendinize ve başkalarına saygı duymayı öğretecek; yüreği ve aklı, dünya ve insanlık sevgisiyle dolduracaktır.” – (Maksim Gorki)||“Otuz yaşına gelinceye kadar kitapları sevmeyen, sonraları da onları anlayacak kadar sevmeyecektir.” – (Clarendon)||“Bir kitap, içimizdeki donmuş denize indirilmiş bir baltadır… Eğer okuduğumuz bir kitap bizi kafamıza vurulan bir darbe gibi sarsmıyorsa, niye okumaya zahmet edelim ki?” – Franz Kafka||“En iyi kitapların okunması, geçmiş yüzyılların en büyük insanlarıyla konuşmak gibidir.” – Descartes||“Kitaplık kurmak, tapınak yapmak kadar kutsaldır.” – (Victor Hugo)||“Yedi eski kitap kafa kafaya verirse, mutlaka bir yenisi doğar.” – (Alman Atasözü)||“Kitaplarda her zaman kendimizi buluruz. Yine de her seferinde okuduğumuzda hayran kalıp yazarını deha olarak adlandırmamız ne tuhaftır.” – (Thomas Mann)||“Her yerde mutluluğu aradım, ama onu sadece küçük bir kitabı okuduğum küçük bir köşede buldum.”||“Mümkün olsaydı her karış toprağa buğday eker gibi kitap ekerdim.”||“Bir kitap, içimizdeki donmuş denize indirilmiş bir baltadır.”||“Kitapların yakıldığı yerde insanlar da yakılır.”||“En iyi kitapların okunması, geçmiş yüzyılların en büyük insanlarıyla konuşmak gibidir.”||“Yatmadan önce okuyabileceğiniz iyi bir kitap ya da dergiye sahip olduğunuzu bilmek zevklerin en büyüğüdür.”||“Kitaplıklar aklın tedavi yerleridir.”||”Ölünce unutulmak istemezseniz, ya okumaya değer eser yazın veya yazılmaya değer işler başarın.”||“Ben kitaplarımı değil, kitaplarım beni ortaya çıkarmıştır.”||“Dünyayı yöneten, kalem, mürekkep ve kağıttır.”||“İyi bir kitap insana can veren kandır.”||“İçinde iyi yanı bulunmayacak kadar kötü kitap yoktur.”||“Kitaplardan insanı tanıdım.”||“Kitaplar soğuk ama, güvenilir dostlardır.”||“Ahlak kurallarına uyan veya uymayan bir kitap diye bir şey yoktur, kitaplar ya iyi yazılmıştır ya kötü.”||“Kitaplar, beynin çocuklarıdır.”||“Bütün iyi kitapları okumak, geçmiş anıların o mükemmel kişileri ile konuşmaya benzer.”||“Yazarlar ölür, kitaplar kalır.”||“Tek bir kitabın adamı olmaktan kendini koru.”||“Okuyun ve kitabı hayatınızın merkezi yapın.”||“Okuduğumuz kitap bir yumruk gibi bizi uyarmıyorsa ne işe yarar?”||“Okuduğumuz eser, sizi fikren yükseltip, içinizi iyi duygularla doldurmalıdır.”||“Ümitle açılıp, kazançla kapanan kitap iyi bir kitaptır.”||“İyi kitaplar okumayan adamın okumuş olmasıyla cahil kalması arasında hiçbir fark yoktur.”||“İyi kitaplar okumayan adamın okumuş olmasıyla cahil kalması arasında hiçbir fark yoktur.”||“En iyi kitapların okunması, geçmiş yüzyılların en büyük insanlarıyla konuşmak gibidir.”||“Okuyarak dünyamızı, tarihimizi ve kendimizi keşfederiz..”||“Asgari okuyan asgari ücrete talim eder.”||“Cümleler zihnimize gerçekleri çakan çivilerdir..”||“Eğer bir insan bir kitabı okuduktan sonra, onu tekrar okumaktan zevk almıyorsa, o kitabı okumuş olmasının bile hiçbir değeri yoktur.” – Oscar Wilde||“Kitaplar sadece ilham vermek içindir..”||“Kitabın hala fikirlerin temel taşıyıcısı olduğuna inanıyorum.”||“Gelecek, ihtiyacı olan şeyleri yapabilmek için neyi öğrenmesi gerektiğini bilenlerindir..”||“Okumak zihni sadece bilgi malzemesiyle doldurur, okuduğumuzu bize mal eden düşünmedir.”||“Süratli okuma hakkında bir kursa gittim ve Savaş ve Barışı 20 dakikada okumayı başardım.” ||“Okuyabilen herkes derinden okumayı ve böylece daha dolu yaşamayı öğrenebilir.”||“İyi yazma dekorasyon değil, mimarlıktır.”||“Okuyanlar iki misli daha iyi görür.”`.split(
            "||"
          )
          : this.$i18n.locale == "en"
            ? `“A reader lives a thousand lives before he dies . . . The man who never reads lives only one.” ||“Until I feared I would lose it, I never loved to read. One does not love breathing.” ||“You can never get a cup of tea large enough or a book long enough to suit me.” ||“I find television very educating. Every time somebody turns on the set, I go into the other room and read a book.” ||“||Classic’ – a book which people praise and don’t read.” ||“So please, oh please, we beg, we pray, go throw your TV set away, and in its place you can install a lovely bookshelf on the wall.” ||“The more that you read, the more things you will know. The more that you learn, the more places you’ll go.” ||“Books are a uniquely portable magic.”||“I kept always two books in my pocket, one to read, one to write in.”||“The person who deserves most pity is a lonesome one on a rainy day who doesn’t know how to read.”||“There is more treasure in books than in all the pirate’s loot on Treasure Island.”||“We are of opinion that instead of letting books grow moldy behind an iron grating, far from the vulgar gaze, it is better to let them wear out by being read.”||“My alma mater was books, a good library…. I could spend the rest of my life reading, just satisfying my curiosity.”||“I have a passion for teaching kids to become readers, to become comfortable with a book, not daunted. Books shouldn’t be daunting, they should be funny, exciting and wonderful; and learning to be a reader gives a terrific advantage.”||“Make it a rule never to give a child a book you would not read yourself.”||“Books serve to show a man that those original thoughts of his aren’t very new after all.”||“The man who does not read good books is no better than the man who can’t.”||“Show me a family of readers, and I will show you the people who move the world.”||“I guess there are never enough books.”||“Despite the enormous quantity of books, how few people read! And if one reads profitably, one would realize how much stupid stuff the vulgar herd is content to swallow every day.”||“If you don’t like to read, you haven’t found the right book.”||“Somebody who only reads newspapers and at best books of contemporary authors looks to me like an extremely near-sighted person who scorns eyeglasses. He is completely dependent on the prejudices and fashions of his times, since he never gets to see or hear anything else.”||“There is no Frigate like a Book To take us Lands away.”`.split(
              "||"
            )
            : `Приобретая привычку к чтению, вы строите для себя убежище практически от всех страданий жизни. – Сомерсет Моэм||Писатель только начинает книгу. Читатель заканчивает ее. – Сэмюель Джонсон||Книги – это уникальная портативная магия. – Стивен Кинг||Книги – это и самолет, и поезд, и дорога. Они и пункт назначения, и путешествие. Они – это дом. – Анна Квиндлен||Книги – маяки, возведенные в великом море времени. – Е. П. Уиппл||Книги – самые тихие и самые постоянные друзья, они самые доступные и мудрейшие советники, и самые терпеливые учителя. – Чарльз Уильям Элиот||Читая, вы проживаете несколько жизней. – Уильям Стайрон||Комната без книг подобна телу без души. – Марк Туллий Цицерон||Наш разум нуждается в книгах, как меч – в точильном камне, чтобы не затупиться. – Тирион Ланнистер (Джордж Марти||Читатель проживает тысячу жизней до того, как умрет. Тот, кто никогда не читает, — только одну.  Джордж Мартин||Книги стали моим пропуском в личную свободу. – Опра Уинфри||Я не верю в ту магию, о которой говорится в моих книгах. Но я верю, что нечто по-настоящему волшебное может произойти, когда вы читаете хорошую книгу. – Джоан Роулинг||Привить ребёнку вкус к чтению – лучший подарок, который мы можем ему сделать. – С.Лупан||Хорошо унаследовать библиотеку, а еще лучше собрать свою собственную. – Огастин Биррелл||Хорошие друзья, хорошие книги и Спящая совесть: вот идеальная жизнь. – Марк Твен||Чтение может быть опасным. – Диана Сеттерфилд||Я нахожу телевидение очень поучительным. Каждый раз, когда кто-то включает телевизор, я иду в другую комнату и читаю книгу. – Граучо Маркс||Мне всегда казалось, что Рай – своего рода библиотека. – Хорхе Луис Борхес||Я родилась с «списком для чтения», который я никогда не смогу закончить. – Мод Кейси||Если есть книга которую вы хотите прочитать, но она еще не написана, то вы должны написать её. – Тони Моррисон||Если вы читали только книги, которые все читают, вы будет думать только то, что все думают. – Харуки Мураками||Мой лучший друг-это человек, который даст мне книгу, которую я не читал. – Авраам Линкольн||Не все читатели являются лидерами, но все лидеры – читателями. – Гарри С. Трумэн||Как только вы научитесь читать, вы будете всегда свободны. – Фредерик Дуглас||Одна из радостей чтения – это возможность подключиться к общей мудрости человечества. – Ишмаэль Рид||Чтение – это льготный билет везде. – Мэри Шмидш||Чтение то же для ума, что упражнения для тела. – Джозеф Аддисон||Чтение уводит нас из дома, но, что более важно, оно находит нам везде дом. – Хейзел Рочман||Чтение – одно из самых больших удовольствий, которое может нам предложить одиночество. – Гарольд Блум||Любовь к книгам – это любовь, которая не требует ни оправдания, извинения, ни обороны. – Ю. А. Лэнгфорд||Прочитав отличную книгу, я словно обретаю замечательного друга. – Оливер Голдсмит||Страсть к чтению – это большой подарок. – Элизабет Хардвик||Человек, который не читает хороших книг, не имеет преимуществ перед человеком, который не умеет читать. – Марк Твен||Мир – это книга, и те, кто не путешествуют, читают только одну страницу. – Святой Августин||Мир книг – самое замечательное творение человека. – Кларенс Шепард Дей||Есть много способов, чтобы расширить мир вашего ребенка. Любовь к книгам – лучший из всех. – Жаклин Кеннеди||`.split(
              "||"
            ),
      loading: true,
      attrs: [],
      activePane: null,
      moment,
      stats: [],
    };
  },
  mounted() {
    axios.get("account/get").then((res) => {
      this.test_required = res.data.data.user.test_required;
      var date = moment().format("YYYY-MM-DD");
      this.loading = false;
      if (res.data.data.user.status.findIndex((k) => k.date == date) == -1) {
        this.$root.$emit("visible");
      }
      this.initChart();
      if (
        res.data.data.user.level == "LGS" ||
        res.data.data.user.level == "YKS" ||
        res.data.data.user.level == "Tüm Sınavlara Hazırlık"
      ) {
        this.initExamChart();
      }
    });

    axios.get("account/report").then((res) => {
      this.stats = res.data.data.map((k) => {
        return {
          ...k,
          gain: parseFloat(k.gain),
          score: parseFloat(k.score),
        };
      });
    });

    axios.get("course/list").then((res) => {
      this.$store.state.courses = this.$prepareCourses(res.data.data);

      var steps = [];

      this.$store.state.courses.map((k) => {
        steps = [...steps, ...k.steps];
      });

      steps = steps.map((k) => {
        return {
          ...k,
          dates: new Date(k.finishedAt),
        };
      });

      this.attrs = steps;
    });
  },
  watch: {
    "$store.state.darkmode": function (newww) {
      this.initChart();
    },
  },
  methods: {
    getStatus(index) {
      var course = JSON.parse(JSON.stringify(this.$store.state.courses[index]));

      course.steps = _.orderBy(
        course.steps,
        ["step", "order_no"],
        ["desc", "desc"]
      );

      if (course.steps.some((k) => k.finishedAt == null) == false) {
        return "finished";
      }
      // get last finished step
      var step = course.steps.find((k) => k.finishedAt != null);
      if (step == null) {
        return "new";
      }
      var last_finished_step = step.program.step;

      // is last step finished?
      var is_last_step_finished =
        course.steps.filter(
          (k) => k.program.step == last_finished_step && k.finishedAt != null
        ).length ==
        course.steps.filter((k) => k.program.step == last_finished_step).length;

      if (is_last_step_finished) {
        // check date is today
        if (
          step.finishedAt.indexOf(moment().format("YYYY-MM-DD")) != -1 &&
          this.$store.state.user.tester == 0
        ) {
          return "today_finished";
        } else {
          return "start_next";
        }
      } else {
        return "continue";
      }
    },
    initChart() {
      var tests =
        this.$store.state.user.level == "İlkokul"
          ? this.$store.state.user.speed_test_io
          : this.$store.state.user.speed_tests;
      if (tests.length < 2) {
        return;
      }

      tests = tests.map((k) => {
        return {
          ...k,
          createdAt: moment(k.createdAt).format("DD.MM.YYYY HH:mm"),
          ordering: new Date(k.createdAt).getTime(),
        };
      });

      tests = _.orderBy(tests, ["ordering"], ["ASC"]);

      am4core.unuseAllThemes();
      if (this.$store.state.darkmode == true) {
        am4core.useTheme(am4themes_dark);
      } else {
        am4core.useTheme(am4themes_material);
      }

      var chart = am4core.create("chartdiv", am4charts.XYChart);
      chart.dateFormatter.dateFormat = "dd.MM.yyyy H:m";
      // Add data
      chart.data = tests;
      // Create axes
      var dateAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.minGridDistance = 1;
      dateAxis.dataFields.category = "createdAt";
      dateAxis.renderer.labels.template.rotation = -80;
      dateAxis.renderer.labels.template.horizontalCenter = "center";
      dateAxis.renderer.labels.template.verticalCenter = "center";

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      if (chart.yAxes.indexOf(valueAxis) != 0) {
        valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
      }
      valueAxis.renderer.labels.template.verticalCenter = "bottom";
      valueAxis.renderer.maxLabelPosition = 0.95;
      valueAxis.title.marginRight = 5;

      var valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      if (chart.yAxes.indexOf(valueAxis2) != 0) {
        valueAxis2.syncWithAxis = chart.yAxes.getIndex(0);
      }
      valueAxis2.renderer.labels.template.verticalCenter = "bottom";
      valueAxis2.renderer.maxLabelPosition = 0.95;
      valueAxis2.title.marginRight = 5;

      valueAxis.renderer.line.strokeOpacity = 1;
      valueAxis.renderer.line.strokeWidth = 2;
      valueAxis.renderer.line.stroke = "#1C449C";
      valueAxis.renderer.labels.template.fill = "#1C449C";

      valueAxis2.renderer.line.strokeOpacity = 1;
      valueAxis2.renderer.line.strokeWidth = 2;
      valueAxis2.renderer.line.stroke = "red";
      valueAxis2.renderer.labels.template.fill = "red";

      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "word_per_minute";
      series.dataFields.categoryX = "createdAt";
      series.yAxis = valueAxis;
      series.name = this.$t("home.reading_speed");
      series.tooltipText = "[bold]{name}[/]\n[b]{valueY}[/]";
      series.strokeWidth = 2;
      series.smoothing = "monotoneX";
      series.stroke = "#1C449C";
      series.tooltip.background.fill = am4core.color("#1C449C");
      series.tooltip.getFillFromObject = false;

      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "understanding_rate";
      series.dataFields.categoryX = "createdAt";
      series.name = this.$t("home.unders");
      series.tooltipText = "[bold]{name}[/]\n[b]{valueY}[/]";
      series.strokeWidth = 2;
      series.smoothing = "monotoneX";
      series.stroke = "red";
      series.yAxis = valueAxis2;
      series.tooltip.background.fill = am4core.color("#FF0000");
      series.tooltip.getFillFromObject = false;

      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
    },
    initExamChart() {
      var tests = this.$store.state.user.speed_test_exam;
      if (tests.length < 2) {
        return;
      }
      am4core.unuseAllThemes();
      if (this.$store.state.darkmode == true) {
        am4core.useTheme(am4themes_dark);
      } else {
        am4core.useTheme(am4themes_material);
      }

      tests = tests.map((k) => {
        return {
          ...k,
          createdAt: moment(k.createdAt).format("DD.MM.YYYY HH:mm"),
          ordering: new Date(k.createdAt).getTime(),
        };
      });

      tests = _.orderBy(tests, ["ordering"], ["ASC"]);

      am4core.unuseAllThemes();
      if (this.$store.state.darkmode == true) {
        am4core.useTheme(am4themes_dark);
      } else {
        am4core.useTheme(am4themes_material);
      }

      var chart = am4core.create("chartdivexam", am4charts.XYChart);
      chart.dateFormatter.dateFormat = "dd.MM.yyyy H:m";
      // Add data
      chart.data = tests;
      // Create axes
      var dateAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.minGridDistance = 1;
      dateAxis.dataFields.category = "createdAt";
      dateAxis.renderer.labels.template.rotation = -80;
      dateAxis.renderer.labels.template.horizontalCenter = "center";
      dateAxis.renderer.labels.template.verticalCenter = "center";

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      if (chart.yAxes.indexOf(valueAxis) != 0) {
        valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
      }
      valueAxis.renderer.labels.template.verticalCenter = "bottom";
      valueAxis.renderer.maxLabelPosition = 0.95;
      valueAxis.title.marginRight = 5;

      var valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      if (chart.yAxes.indexOf(valueAxis2) != 0) {
        valueAxis2.syncWithAxis = chart.yAxes.getIndex(0);
      }
      valueAxis2.renderer.labels.template.verticalCenter = "bottom";
      valueAxis2.renderer.maxLabelPosition = 0.95;
      valueAxis2.title.marginRight = 5;

      valueAxis.renderer.line.strokeOpacity = 1;
      valueAxis.renderer.line.strokeWidth = 2;
      valueAxis.renderer.line.stroke = "#1C449C";
      valueAxis.renderer.labels.template.fill = "#1C449C";

      valueAxis2.renderer.line.strokeOpacity = 1;
      valueAxis2.renderer.line.strokeWidth = 2;
      valueAxis2.renderer.line.stroke = "red";
      valueAxis2.renderer.labels.template.fill = "red";

      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "word_per_minute";
      series.dataFields.categoryX = "createdAt";
      series.yAxis = valueAxis;
      series.name = this.$t("home.reading_speed");
      series.tooltipText = "[bold]{name}[/]\n[b]{valueY}[/]";
      series.strokeWidth = 2;
      series.smoothing = "monotoneX";
      series.stroke = "#1C449C";
      series.tooltip.background.fill = am4core.color("#1C449C");
      series.tooltip.getFillFromObject = false;

      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "understanding_rate";
      series.dataFields.categoryX = "createdAt";
      series.name = this.$t("home.unders");
      series.tooltipText = "[bold]{name}[/]\n[b]{valueY}[/]";
      series.strokeWidth = 2;
      series.smoothing = "monotoneX";
      series.stroke = "red";
      series.yAxis = valueAxis2;
      series.tooltip.background.fill = am4core.color("#FF0000");
      series.tooltip.getFillFromObject = false;

      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
    },
    initStatChart(data, id, type, text) {
      if (data.length == 0) {
        return;
      }
      am4core.unuseAllThemes();
      if (this.$store.state.darkmode == true) {
        am4core.useTheme(am4themes_dark);
      } else {
        am4core.useTheme(am4themes_material);
      }

      var chart = am4core.create(id, am4charts.XYChart);
      chart.dateFormatter.dateFormat = "DD.MM.YYYY";
      // Add data
      chart.data = data.filter((k) => k.types == type);
      // Create axes
      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;
      dateAxis.renderer.minGridDistance = 1;
      dateAxis.skipEmptyPeriods = true;
      dateAxis.baseInterval = {
        timeUnit: "day",
        count: 1,
      };
      dateAxis.dateFormats.setKey("day", "dd.MM.YYYY");
      dateAxis.periodChangeDateFormats.setKey("day", "dd.MM.YYYY");
      dateAxis.renderer.labels.template.rotation = -80;
      dateAxis.renderer.labels.template.horizontalCenter = "center";
      dateAxis.renderer.labels.template.verticalCenter = "center";

      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.renderer.inside = true;
      valueAxis.renderer.labels.template.verticalCenter = "bottom";
      valueAxis.renderer.maxLabelPosition = 0.95;
      valueAxis.title.marginRight = 5;

      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "gain";
      series.dataFields.dateX = "dd";
      series.name = this.$t("cats." + text);
      series.tooltipText = "[bold]{name}[/]\n[b]{valueY}[/]";
      series.strokeWidth = 2;
      series.smoothing = "monotoneX";
      series.stroke = "#1C449C";

      dateAxis.labelRotation = 45;

      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
    },
  },
};
</script>

<style lang="less">
@media (max-width: 768px) {
  ._title_wrapper {
    flex-direction: column !important;
  }

  ._title_box {
    width: 100%;
  }
}

.is-dark {
  .char.custom.typed {
    color: white !important;
  }
}
</style>

<style lang="less">
.custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 40px;
  --day-height: 45px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;
  border-radius: 0;
  width: 100%;

  & .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
  }

  & .vc-weeks {
    padding: 0;
  }

  & .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }

  & .vc-day {
    padding: 0 5px 3px 5px;
    text-align: left;
    height: var(--day-height);
    min-width: var(--day-width);
    background-color: white;

    &.weekday-1,
    &.weekday-7 {
      background-color: #eff8ff;
    }

    &:not(.on-bottom) {
      border-bottom: var(--day-border);

      &.weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }

    &:not(.on-right) {
      border-right: var(--day-border);
    }
  }

  & .vc-day-dots {
    margin-bottom: 5px;
  }
}

.main-banner-item {
  background-image: url(/static/img/main-banner-bg.jpg);
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
  height: 700px;
}
</style>

<style>
/*================================================
Main Banner Area CSS
=================================================*/
.main-banner {
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.main-banner-item {
  background-image: url(/static/img/main-banner-bg.jpg);
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
  height: 700px;
}

.main-banner-item .container-fluid {
  padding-right: 0;
}

.main-banner-item.banner-item-two {
  background-image: unset;
  background-color: #f5edec;
}

.main-banner-item.banner-item-three {
  background-image: url(/static/img/main-banner-bg-2.jpg);
  background-attachment: fixed;
}

.main-banner-item.banner-item-three .main-banner-content {
  max-width: 630px;
  margin: auto;
  text-align: center;
}

.main-banner-item.banner-item-four {
  background-image: unset;
  background-color: #73548f;
}

.main-banner-content {
  max-width: 630px;
  margin-left: auto;
}

.main-banner-content span {
  font-size: 16;
  font-weight: 600;
}

.main-banner-content h1 {
  font-size: 60px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.main-banner-content p {
  margin-bottom: 0;
}

.main-banner-content .banner-btn {
  margin-top: 25px;
}

.main-banner-image-wrap {
  position: relative;
  text-align: center;
  z-index: 1;
}

.main-banner-image-wrap .banner-image-wrap-shape {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: -1;
  left: 0;
  right: 0;
}

.main-banner-shape .banner-bg-shape {
  position: absolute;
  bottom: -75px;
  left: 0;
  right: 0;
  z-index: 1;
}

.main-banner-shape .banner-bg-shape-2 {
  position: absolute;
  top: -75px;
  left: 0;
  right: 0;
  z-index: 1;
}

.main-banner-shape .shape-1 {
  position: absolute;
  top: 25px;
  transform: translateY(-25px);
  left: 25px;
  transform: translateX(-25px);
  z-index: 1;
  max-width: 100px;
  animation: moveLeftBounce 3s linear infinite;
}

.main-banner-shape .shape-2 {
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  max-width: 100px;
  animation: moveLeftBounce 3s linear infinite;
}

.main-banner-shape .shape-3 {
  position: absolute;
  bottom: 100px;
  left: 30px;
  z-index: 1;
  max-width: 100px;
  animation: moveLeftBounce 3s linear infinite;
}

.main-banner-shape .shape-4 {
  position: absolute;
  bottom: 30px;
  transform: translateY(-30px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  max-width: 100px;
  animation: moveBounce 5s linear infinite;
}

.main-banner-shape .shape-5 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  max-width: 210px;
}

.main-banner-shape .shape-6 {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  max-width: 230px;
}

.banner-child .child-1 {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  animation: moveBounce 5s linear infinite;
}

.banner-child .child-2 {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 1;
  animation: moveBounce 5s linear infinite;
}

@keyframes rotateMe {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes rotate3d {
  0% {
    transform: rotateY(0deg);
  }

  100% {
    transform: rotateY(360deg);
  }
}

@keyframes moveScale {
  0% {
    transform: scale(0.6);
  }

  50% {
    transform: scale(0.8);
  }

  100% {
    transform: scale(0.6);
  }
}

@keyframes moveLeftBounce {
  0% {
    transform: translateX(0px);
  }

  50% {
    transform: translateX(20px);
  }

  100% {
    transform: translateX(0px);
  }
}

@keyframes moveBounce {
  0% {
    transform: translateY(0px);
  }

  50% {
    transform: translateY(20px);
  }

  100% {
    transform: translateY(0px);
  }
}

@keyframes border-transform-default {

  0%,
  to {
    border-radius: 63% 37% 54% 46%/55% 48% 52% 45%;
  }

  14% {
    border-radius: 40% 60% 54% 46%/49% 60% 40% 51%;
  }

  28% {
    border-radius: 54% 46% 38% 62%/49% 70% 30% 51%;
  }

  42% {
    border-radius: 61% 39% 55% 45%/61% 38% 62% 39%;
  }

  56% {
    border-radius: 61% 39% 67% 33%/70% 50% 50% 30%;
  }

  70% {
    border-radius: 50% 50% 34% 66%/56% 68% 32% 44%;
  }

  84% {
    border-radius: 46% 54% 50% 50%/35% 61% 39% 65%;
  }
}

.el-collapse-item__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 48px;
  line-height: 48px;
  background-color: #102d47;
  color: #fff;
  cursor: pointer;
  border-bottom: 1px solid #103556;
  font-size: 17px;
  font-weight: 500;
  color: white;
  -webkit-transition: border-bottom-color 0.3s;
  transition: border-bottom-color 0.3s;
  outline: 0;
  padding-left: 15px;
}

.el-collapse:first-child .el-collapse-item__header {
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.el-collapse:last-child .el-collapse-item__header {
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue